<!-- Title -->
<div class="text-center" *ngIf="page < 23">
    <h1>Module 4 - Getting Through the Rental Process, Your Credit Report, Moving In</h1>
</div>

<!-- Module Content -->
<div id="module4">
    <section>
        <div *ngIf="page === 1">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Getting Through the Rental Process</h2>
                <p><i>After deciding what is affordable and searching for suitable housing, you will need to complete a rental application, go through the landlord‘s rental screening process, inspect the unit, sign a lease agreement, and move in.</i></p>

                <h3>Rental Application</h3>
                <p>Providing a neat, accurate, complete application will help convince the landlord you are the tenant he or she wants in the unit. Incomplete and inaccurate rental applications give landlords a reason to deny your rental application. Landlords
                    can legally refuse an application that is incomplete. Inaccurate information on an application is grounds for eviction. Use your complete name, including your full middle name, to ensure that the rental screening report belongs to
                    you, not to a person with a similar name.</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Treat the rental application with the same importance as a job application.</li>
                    <li class="bullet-point">Be honest; be complete; be neat.</li>
                    <li class="bullet-point">Before paying an application fee, ask about criteria such as income, rental history, etc.</li>
                </ul>
                <p>The most common reasons that rental applications are denied:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">missing or inaccurate information</li>
                    <li class="bullet-point">poor credit history</li>
                    <li class="bullet-point">poor references</li>
                    <li class="bullet-point">inadequate or unstable income</li>
                </ul>
                <p>Develop your own rental history and resume. Having this information will make it easier to accurately fill out the rental application form.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" [routerLink]="'/RentWise'"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 2">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Giving Information to Landlords</h2>
                <p>Information Landlords may request:</p>
                <ul class="bullet-points">
                    <li class="bullet-point"><b>Social security number</b> to run credit and criminal histories</li>
                    <li class="bullet-point"><b>Names of all people who will be living in the unit.</b> Landlords often restrict the number of people in a unit. Each adult may have to complete an application and be responsible for the full rent if another adult moves out.</li>
                    <li class="bullet-point"><b>References</b> from places you have lived in for the last three years. Be prepared to provide addresses.</li>
                    <li class="bullet-point"><b>Income and employment information</b> to determine you have the ability to pay the rent.</li>
                </ul>
                <p>Information Landlords should not request:</p>
                <p>Information that identifies protected class such as race, age, marital status, gender, or participation in public assistance programs.</p>

                <h3>Common Applicant Screening Practices</h3>
                <p>Landlords set their own criteria for screening applicants. Most will:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Look at your credit report.</li>
                    <li class="bullet-point">Talk to your employer to find out about your ability to pay the rent and stability of employment.</li>
                    <li class="bullet-point">Talk to previous landlords.</li>
                    <li class="bullet-point">Look at any criminal history.</li>
                    <li class="bullet-point">Verify that you have paid your utilities (heat, electric, phone).</li>
                </ul>
                <h3>Screening Agencies</h3>
                <p>Many landlords will contract with another agency to screen applicants.</p>
                <ul class="bullet-points">
                    <li class="bullet-point">The agency collects information and sells a summary to landlords.</li>
                    <li class="bullet-point">If the landlord charges a screening fee, laws require that it be used to buy reports and check references.</li>
                    <li class="bullet-point">The landlord is not required to share the report with you.</li>
                    <li class="bullet-point">The landlord must tell you the name, address and phone number of the agency. You can request a copy of the report from the screening agency.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 3">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video1 src="https://www.youtube.com/embed/sbHWBVkivys" width="900" height="620" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video1.duration / video1.speed" [delay-until]="video1.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 4">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Fair Housing</h2>
                <p>Fair Housing laws apply to landlords, real estate brokers, and lenders. Under these laws:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">There must be equal treatment for all inquiries and applications.</li>
                    <li class="bullet-point">There must be equal treatment for making repairs.</li>
                    <li class="bullet-point">There must be equal treatment regarding consequences for lease violations.</li>
                </ul>
                <p>It is against state and federal laws to be denied housing because of the race of the tenant, color, national origin, religion, sex, family status, and disabilities.</p>
                <p>This section of RentWise will provide an overview of housing discrimination and some examples in which discrimination may or may not have occurred. This information is not intended to serve as a legal document or interpretation of the
                    law. It is provided for awareness and educational purposes only. For more information, contact the agencies listed at the end of this publication or legal professionals.</p>

                <h3>The Nebraska Fair Housing Act</h3>
                <p><i>The Nebraska Fair Housing Act</i> is a law that protects everyone’s right to freely choose a place to live in peace and dignity without experiencing discrimination, harassment or intimidation.</p>
                <h4>Housing Discrimination</h4>
                <p><i>Housing Discrimination</i> is a difference in treatment because of a person’s “protected class” status (i.e., race, color, national origin, religion, disability, sex, or because they have children). It is illegal. Anyone who believes
                    they have experienced discrimination has a right to file a charge within 365 days from the date of harm. The following information will help you determine if you need to speak with someone about how you were treated when looking for
                    housing to buy or rent.</p>
                <p>When you are seeking to rent property, be suspicious and alert when you hear statements like these:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">“I rented that apartment right after you called.”</li>
                    <li class="bullet-point">“This building is for adults only.”</li>
                    <li class="bullet-point">“You might not fit in.”</li>
                </ul>
                <p>When you are seeking to purchase property, be suspicious when you hear statements like these:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">“Do you think you can afford this neighborhood?”</li>
                    <li class="bullet-point">“The owner just took the house off the market.”</li>
                </ul>
                <p>All of the above <i>may be evidence</i> of illegal discrimination. Sometimes it is difficult to tell if you are being treated fairly. Do you feel uncomfortable when a housing provider fails to shake your hand, does not extend common courtesies,
                    shows you an apartment that is dirty or has other conditions that could pose safety hazards?</p>
                <p>When you feel uncomfortable, you may decide not to pursue the housing of your choice. You may have experienced housing discrimination because you are in one or more protected classes. If the housing provider’s actions are inconsistent
                    with placing you in the housing you seek, you may be experiencing housing discrimination.</p>
                <p>Discrimination occurs when people are not allowed to complete an application, are told that housing is not available or are not given enough information to make an informed decision because of their protected class. The law allows everyone
                    to enjoy equal housing opportunities and makes it illegal to discriminate based on a person’s protected class. The law covers all housing activities.</p>
                <p><strong>You have 365 days from the date of the last harm to file a charge of discrimination.</strong></p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="30" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 5">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video2 src="https://www.youtube.com/embed/IHP6AuoIP58" width="900" height="620" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video2.duration / video2.speed" [delay-until]="video2.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 6">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Discriminatory Housing Activities</h2>
                <p>Discriminatory housing activities can include:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">the refusal to sell, rent or make the property available;</li>
                    <li class="bullet-point">the denial or delay of housing services (such as maintenance work, repairs, etc.);</li>
                    <li class="bullet-point">different terms and conditions in the use of facilities (such as using the laundry room, club house, playground or swimming pool);</li>
                    <li class="bullet-point">the denial of a mortgage loan or an accommodation.</li>
                </ul>
                <p>According to the Nebraska Fair Housing Act, the refusal of an owner occupying a property with more than one secured entrance to rent to a tenant based on any of the seven protected classes is discrimination.</p>
                <p>The decision to file a complaint regarding your treatment is, of course, up to you. Making a timely and informed decision will preserve your rights.</p>
                <h4>What Housing Is Not Covered?</h4>
                <p>Most housing activities are covered under the law. The exceptions include housing operated by organizations, institutions, and private clubs that limit who may live in the house to its members, and housing set aside for older persons.</p>
                <h4>Who May File Under the Fair Housing Act?</h4>
                <p>Anyone who has been harmed as a result of discrimi­nation in a housing activity may file under one or more of the protected classes, including a person who:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">is directly harmed;</li>
                    <li class="bullet-point">is associated with someone who is directly harmed;</li>
                    <li class="bullet-point">participated in an investigation as a witness and was harmed;</li>
                    <li class="bullet-point">opposed an illegal housing practice and was harmed.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 7">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Types of Discrimination</h2>
                <h4>Race</h4>
                <p>Race refers to people of all races, including but not limited to, white people with European, North African or Middle Eastern ancestry, who are not Hispanic. Race includes black people having origins in any of the black racial groups of
                    Africa but who are not of Hispanic origin. (In this publication, Hispanic is not a race but is covered under national origin.)</p>
                <section>
                    <h5>Example of Race Discrimination</h5>
                    <p>A black applicant for a mortgage loan is required to provide proof that he/she has been employed for three years or more with the same company. The lender does not make a white applicant provide the same kind of information.</p>
                </section>
                <h4>Color</h4>
                <p>Different skin colors exist, even within racial groups, and some people may believe they have been treated unfairly because of their skin color. Generally, people have filed charges because they were discriminated against as a result of
                    being lighter-skinned or darker-skinned.</p>
                <section>
                    <h5>Example of Color Discrimination</h5>
                    <p>A lighter-skinned person from India, who is the landlord, refuses to rent to a darker-skinned person from India. Discrimination also may occur when a white landlord provides favorable terms of rental to lighter-skinned blacks and treats
                        darker-skinned blacks unfavorably.</p>
                </section>
                <h4>National Origin</h4>
                <p>A person may file national origin discrimination in one or more of these categories:</p>
                <ul class="bullet-points">
                    <li class="bullet-point"><i>Hispanic:</i> All persons of Mexican, Puerto Rican, Cuban, Central or South American decent, or from other Spanish cultures without regard to race.</li>
                    <li class="bullet-point"><i>Asian or Pacific Islander:</i> All persons of the Far East, Southeast Asia, the Indian Sub-Continent or the Pacific Islands. Included are: China, Japan, Korea, the Philippine Islands, and Samoa.</li>
                    <li class="bullet-point"><i>American Indian or Alaskan Native:</i> All persons having origins in any of the original people of North America.</li>
                </ul>
                <section>
                    <h5>Examples of National Origin Discrimination</h5>
                    <ul class="bullet-points">
                        <li class="bullet-point">A person from Mexico with a Spanish accent calls to ask about the availability of an apartment that has been advertised for rent. The landlord says it is not available, when in fact it is.</li>
                        <li class="bullet-point">People with Chinese physical characteristics made an appointment to view an apartment they were told was available. They arrived 30 minutes later and were not allowed to see the apartment.</li>
                    </ul>
                </section>
                <h4>Religion</h4>
                <p>Showing a preference for or against a religious group, or showing intolerance for that group’s observation of its religious practices or dietary habits is religious discrimination.</p>
                <section>
                    <h5>Examples of Religious Discrimination</h5>
                    <p>A housing provider refuses to show or rent a vacant apartment to someone who declines to reveal his or her religious beliefs, or who practices a religion the landlord considers different.</p>
                </section>
                <h4>Sex</h4>
                <p>Sex discrimination is defined as being treated differently because of gender. Both women and men may experience illegal discrimination in housing because of their gender. This protected class includes sexual harassment.</p>
                <section>
                    <h5>Examples of Sex Discrimination</h5>
                    <ul class="bullet-points">
                        <li class="bullet-point">A landlord rents to single women living together but will not rent to single men who want to live together.</li>
                        <li class="bullet-point">A housing provider (of the same or different sex) demands that you sleep with him/her to rent the apartment or have repairs made.</li>
                    </ul>
                </section>
                <h4>Familial Status</h4>
                <p>Familial status refers to the presence of children under the age of 18 who are members of the household because of their birth, adoption or because they have been legally placed in the household. Discrimination in this protected class
                    includes placing limitations on the number or age of the children in the family.</p>
                <section>
                    <h5>Examples of Familial Status Discrimination</h5>
                    <ul class="bullet-points">
                        <li class="bullet-point">A woman is evicted from her apartment because she is pregnant.</li>
                        <li class="bullet-point">A household with children is charged a higher security deposit than a household without children.</li>
                    </ul>
                </section>
                <section>
                    <h4>Examples of Discrimination Not Covered by the Federal Fair Housing Law</h4>
                    <p>Federally funded properties prohibit discrimination based on sexual orientation or age. Some communities have local ordinances that prohibit discrimination based on sexual orientation.</p>
                </section>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="45" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 8">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video3 src="https://www.youtube.com/embed/dcSGxxaxQ1w" width="900" height="620" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video3.duration / video3.speed" [delay-until]="video3.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 9">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Where Should I Go If I Feel I Have Been Discriminated Against?</h2>
                <p>Several agencies and organizations assist persons who have experienced housing discrimination. These services are provided without cost. It is your responsibility and right to report violations of the housing law. Failure to report violations
                    or file a complaint will impact others and may lead to the continuation of discrimination.</p>
                <p>When a person suspects they may have been denied an equal housing opportunity, they have 365 days from the last harm to file a complaint with an enforcement agency.</p>
                <section>
                    <p>For more information or to file a complaint, contact one of the following enforcement agencies:</p>
                    <p>Nebraska Equal Opportunity Commission<br>301 Centennial Mall South – 5th Floor<br>PO Box 94934<br>Lincoln, NE 68509-4934<br>(402) 471-2024<br>(800) 642-6112<br></p>
                    <p>Nebraska Equal Opportunity Commission<br>1313 Farnam-on-the-Mall<br>Omaha, NE 68102-1936<br>(402) 595-2099</p>
                    <p>Nebraska Equal Opportunity Commission<br>505A Broadway, Suite 600<br>Scottsbluff, NE 69361-3515<br>(308) 632-1340<br>(800) 830-8633</p>
                    <p>Lincoln Commission on Human Rights<br>440 South 8th Street, Suite 101<br>Lincoln, NE 68508-2294<br>(402) 441-8691</p>
                    <p>Omaha Human Relations Department<br>Omaha/Douglas Civic Center<br>1819 Farnam Street, Suite 502<br>Omaha, NE 68183-0502<br>(402) 444-5055</p>
                    <p>Department of Housing & Urban Development<br>Edward Zorinsky Federal Bldg<br>1616 Capitol Avenue, Suite 329<br>Omaha, NE 68102-4908<br>(402) 492-3100</p>
                    <p>For More Information Contact:</p>
                    <p>Family Housing Advisory Service, Inc.<br>Fair Housing Center of Nebraska<br>2401 Lake Street<br>Omaha, NE 68111-3872<br>(402) 934-6669</p>
                    <p>If you have any suspicion you have experienced discrimination, contact any of the above agencies. Your inquiry is confidential.</p>
                    <small><i>The Fair Housing segment was developed by Shirley Niemeyer and LaDeane Jha in cooperation with the Nebraska Equal Opportunity Commission.</i></small>
                    <small><i>© 2005-2013, The Board of Regents of the University of Nebraska. All rights reserved.</i></small>
                </section>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="45" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 10">
            <div class="container module-content text-center content-box">
                <h1>Watch the Video Below</h1>


                <!-- EDIT PAST THIS LINE -->


                <app-youtube-player #video4 src="https://www.youtube.com/embed/6-LLqGhJ7Ec" width="900" height="620" autoplay></app-youtube-player>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="video4.duration / video4.speed" [delay-until]="video4.isCompleted" delay-tooltip="Watch the whole video to the end first.">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 11">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Disability Discrimination</h2>
                <h4>Disabilities</h4>
                <p>Under the law, a person with a disability is someone:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">with a physical or mental condition that greatly limits one or more of his/her major life activities. Major life activities include (but are not limited to) walking, talking, seeing, hearing, learning, working, breathing, etc.;</li>
                    <li class="bullet-point">with a record of such a condition; or</li>
                    <li class="bullet-point">perceived as having such a condition.</li>
                </ul>
                <p>If persons with disabilities have suffered housing discrimination, they should speak with someone who knows the law, such as the agencies listed at the end of this section.</p>
                <p>If a property is not accessible, a person should discuss accommodations and modifications with the housing provider. <i>Accommodations</i> can include adjustments in policies, practices or procedures. <i>Modifications</i> include physical
                    changes to the structure.
                </p>
                <h4>Disability Discrimination</h4>
                <h5>Accommodation</h5>
                <p>A landlord with a “no pet” policy does not allow a person with a mental or physical disability to have a service animal or companion animal.</p>
                <h5>Modification</h5>
                <p>A tenant in a wheelchair requests a cabinet under a sink be removed to gain access to the sink.</p>
                <p><b>Note: </b>The landlord may charge for the cost of making a modification in some instances.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="15" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 12">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Your Credit Report</h2>
                <p><i>Your credit report contains information about how you have paid your debts. Companies called credit bureaus collect the information about your credit transactions from your creditors, employers, and public records. The three major credit
                            bureaus are Equifax, Experian and Trans Union.</i></p>
                <h3>Getting a Copy of Your Credit Report</h3>
                <p>Everyone may obtain one free copy of their credit report once a year from each credit bureau. Consumers are encouraged to obtain and review their credit reports annually. They may contain errors which may affect the cost and availability
                    of your credit. The consumer can get errors corrected. Reviews also help detect possible identity theft fraud.</p>
                <p>Free credit reports can be obtained in three different ways (a request form to order all three at one time may be printed from <a href="https://www.consumer.ftc.gov/sites/www.consumer.ftc.gov/files/articles/pdf/pdf-0093-annual-report-request-form.pdf">here</a>):</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Use the central source at <a href="https://www.annualcreditreport.com">www.annualcreditreport.com</a> <b> for a FREE report.</b></li>
                    <li class="bullet-point">Call toll-free (877) 322-8228</li>
                    <li class="bullet-point">Write to
                        <blockquote>
                            Annual Credit Request Service<br> P.O. Box 105283<br> Atlanta, GA 30348-5283
                        </blockquote>
                    </li>
                </ul>
                <p>You will need to provide the following information:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Full name (including Jr. Sr., III, etc.)</li>
                    <li class="bullet-point">Current address and addresses for the last two years</li>
                    <li class="bullet-point">Social Security number</li>
                    <li class="bullet-point">Date of birth</li>
                </ul>
                <p>For security, each credit bureau may also request other information only you should know such as monthly rent payment or something about your cell phone bill. Credit reports ordered by phone or mail will come in about 15 days.</p>
                <p>For addresses of credit reporting agencies, contact your local financial institutions or credit-counseling agency. To get your credit report, you need to request a copy from all three credit bureaus. Use the central source at www.annualcreditreport.com
                    for <b>FREE</b> copies from each.</p>
                <p>There are many free credit score monitoring companies online. These can be a useful product but there are a few things to consider before signing up. Even though these companies provide a free service their goal may ultimately be to move
                    you into a paid service or to advertise credit cards and other financial products to you. Always be careful about the terms of service. Also, free credit providers may not use the exact same scoring methodology as traditional credit
                    bureaus. The best way to use a free credit score provider is to track your score over a long period of time. In order to do this successfully be sure to stick with the same score provider to ensure consistency.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="45" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 13">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Credit Reporting Bureaus:</h2>
                <p>Equifax Credit<br>Information Service Center<br>P.O. Box 740241<br>Atlanta, GA 30374-0241<br>(800) 685-1111<br><a href="https://www.Equifax.com">www.Equifax.com</a></p>
                <p>Experian<br>National Consumer<br>Assistance Center<br>P.O. Box 949<br>Allen, TX 75013-2104<br>(800) 397-3742<br><a href="https://www.experian.com">www.experian.com</a></p>
                <p>Trans Union<br>Corporation Consumer<br>Disclosure Center<br>P.O. Box 390<br>Springfield, PA 19064-0390<br>(800) 888-4213<br><a href="https://www.transunion.com">www.transunion.com</a></p>
                <section>
                    <h3>Be aware of the following:</h3>
                    <ul class="bullet-points">
                        <li class="bullet-point">You are not required to make any purchases to obtain the free report.</li>
                        <li class="bullet-point">To get a free report online, use only the specific address, <a href="https://www.annualcreditreport.com">www.annualcreditreport.com</a>. Many other sites will advertise free credit reports, but they will likely ask for a credit
                            card number, which enrolls you in a monthly service fee.</li>
                        <li class="bullet-point">Credit bureaus will not be contacting consumers by e-mail, phone, mail, or through pop-up ads on a computer. Any offers like this should be ignored to protect against fraud.</li>
                    </ul>
                </section>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 14">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>More About Credit Reports</h2>
                <h3>Correcting Errors on Your Credit Report</h3>
                <p>To correct errors on your credit report, you need to contact the credit bureau that is showing erroneous information.</p>
                <h3>Things Landlords Check on Credit Reports</h3>
                <ul class="bullet-points">
                    <li class="bullet-point">Record of payment</li>
                    <li class="bullet-point">Utilities</li>
                    <li class="bullet-point">Pattern of unpaid bills</li>
                    <li class="bullet-point">Number of applications to landlords</li>
                    <li class="bullet-point">Addresses match</li>
                    <li class="bullet-point">Social Security number matches</li>
                    <li class="bullet-point">Payment plans applicant is committed to</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 15">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>What to Look for in Your Credit Report</h2>
                <p>It is important you look over your credit report for the following information to make sure it is accurate. This is the information your landlord will use to decide whether or not to rent to you.</p>
                <h4>Identification Information</h4>
                <p>Does your name(s), Social Security number, and current and former addresses match what is listed on your application?</p>
                <h4>Employment Data</h4>
                <p>Does your current employer, length of employment, and previous employers match what is listed on your application?</p>
                <h4>Public Records</h4>
                <p>Do you have bankruptcies, evictions, and/or court judgments to pay? Who do you owe and how much do you owe?</p>
                <h4>Bill Paying History</h4>
                <p>What loans have you received (including car loans, appliance loans, and credit cards)? Do you have unpaid or overdue bills on utilities, phone, and medical expenses?</p>
                <h4>Inquiries</h4>
                <p>What businesses or individuals have requested credit card information on you?</p>
                <h4>Hawk Alert</h4>
                <p>Is there a hawk alert on your credit (or a warning to creditors on possible credit fraud)?</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="10" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 16">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Improving Credit History</h2>
                <p>Here is a list of suggestions for improving your credit history:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Stabilize employment — stay for more than one year.</li>
                    <li class="bullet-point">Stabilize housing — move less than once a year.</li>
                    <li class="bullet-point">Establish a saving account with regular deposits.</li>
                    <li class="bullet-point">Have a telephone bill in your name.</li>
                    <li class="bullet-point">Budget payments on utility bills.</li>
                    <li class="bullet-point">Get financial counseling if needed.</li>
                    <li class="bullet-point">Deal with overdue bills.</li>
                    <li class="bullet-point">Avoid credit repair service.</li>
                    <li class="bullet-point">Avoid payday lenders because interest rates may be very high.</li>
                </ul>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="5" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section *ngIf="page === 17">
        <div *ngVar="{ downloaded: false, validate: false } as content">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Sample Credit Report Order</h2>
                <p>One way that a free credit report can be obtained is by sending a letter to a credit reporting bureau. The sample letter is made up. When you write your letter, use your personal information.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


                <div class="text-center">
                    <button type="button" class="btn waves-dark w-25" (click)="downloadOrder(); content.downloaded = true" [class.invalid]="content.validate && !content.downloaded">Download Handout</button>

                    <div class="invalid-feedback d-block" *ngIf="content.validate && !content.downloaded">
                      Download and review handout first.
                    </div>
                </div>

            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="content.downloaded ? next($event) : content.validate = true" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section *ngIf="page === 18">
        <div *ngVar="{ downloaded: false, validate: false } as content">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Sample Letter about an Incorrect Credit Report</h2>
                <p>If you find there is something incorrect on your credit report you should write a letter. The sample letter is made up. When you write your letter, use the current date and real names, addresses, and phone numbers. Use the sample letter
                    below as a guide.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


                <div class="text-center">
                    <button type="button" class="btn waves-dark w-25" (click)="downloadLetter(); content.downloaded = true" [class.invalid]="content.validate && !content.downloaded">Download Handout</button>

                    <div class="invalid-feedback d-block" *ngIf="content.validate && !content.downloaded">
                      Download and review handout first.
                    </div>
                </div>

            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="content.downloaded ? next($event) : content.validate = true" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 19">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Moving In</h2>
                <p><i>Once you have found a place to live, you will need to do a move-in inspection, pay a security deposit, and sign a lease agreement.</i></p>
                <h3>The Move-in Inspection</h3>
                <p>Most landlords require you to pay a security deposit before you move in. The purpose of the security deposit is to pay for any damage that occurs while you live there. The best way for you to make sure you get back your security deposit
                    when you move out is to do a detailed inspection with the landlord <b>before</b> moving in.</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Complete the <i>Rental Condition Checklist Worksheet 10</i> in your <i>Organizer</i> during the inspection.</li>
                    <li class="bullet-point">Have the landlord or property manager sign it.</li>
                    <li class="bullet-point">If possible, take pictures or make a video of the unit before you move in.</li>
                    <li class="bullet-point">Store pictures and checklist in your <i>Organizer</i> as a record.</li>
                </ul>
                <p>In general, you should be looking for the following problems during your move-in inspection:</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Missing items: ice-cube trays, window screens, broiler pans</li>
                    <li class="bullet-point">Damaged items: cracked windows, burned or scratched counters, bath fixtures and floors</li>
                    <li class="bullet-point">Dirty items: grime on cooking surfaces and bath fixtures, dirty carpets and walls</li>
                    <li class="bullet-point">Excessive wear: carpet, vinyl flooring, cabinets, woodwork, window coverings, etc.</li>
                    <li class="bullet-point">Working condition of appliances, heating and cooling equipment, plumbing, etc.</li>
                </ul>
                <p>The primary goal of the inspection is to identify items that may end up as deductions from the security deposit if not called to the landlord’s attention before moving in. The inspection will help you make sure everything is in working
                    order before you move in and that you know how to operate and care for equipment in the unit.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="20" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 20">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Lease Agreements</h2>
                <p>A lease agreement is a legal contract between the landlord and the tenant. The terms of any lease agreement are stated in the lease. Ask for a written lease agreement. Written agreements give you a record of the terms and are easier to
                    enforce if there is a problem. Keep a copy of the lease in the back pocket of the <i>RentWise Organizer</i>.</p>
                <p>You need to understand the lease agreement before committing to renting a new home. Most written lease agreements use a standard form. Some landlords add conditions that are handwritten or typed into or attached to the form. This is legal,
                    but occasionally the conditions may not abide by the law. Read these additional conditions very carefully. If something does not seem fair to you, check with an attorney or with one of the resources listed in the Organizer. Tenants
                    should also read any building rules and policies before signing a lease agreement that specifies that those rules are a binding part of the lease. These rules or policies should be kept in the Organizer.</p>
                <p><b>Remember: When rules, policies, and lease agreements are in writing, they can be enforced.</b></p>
                <h3>What You Need to Know Before Signing a Lease Agreement:</h3>
                <p>Here are some things you should find out before signing a lease agreement.</p>
                <h4>Lease Term</h4>
                <p>When does this lease end? What happens if you move out before your lease period ends?</p>
                <h4>Rent</h4>
                <p>How much is the rent? When is the rent due? Where do you pay the rent? To whom do you pay your rent? Is there a penalty for late payment? If so, what is it? When can the rent be increased? Who is responsible for the rent? How much is the
                    security deposit?
                </p>
                <h4>Utilities and Fees</h4>
                <p>What utilities must you pay? Are there other payments you must make in addition to rent, such as security deposit, parking, or utilities?</p>
                <h4>Moving Out</h4>
                <p>How should the apartment look when you move out?</p>
                <h4>Maintenance</h4>
                <p>Are you responsible for maintenance and repairs? To whom do you report problems?</p>
                <h4>Other</h4>
                <p>When can the landlord enter the apartment? Are pets permitted? How do you become eligible for a tax credit? How long can visitors stay with you? If they stay longer, what happens?</p>
                <p>If you cannot find this information in your lease or other building policy and rules, ask the landlord for the information in writing.</p>
                <p>For complete information, read the <i>Nebraska Uniform Residential Landlord and Tenant Act</i>, available free at: <a href="https://www.nrec.nebraska.gov/legal/landlordacttoc.html">www.nrec.nebraska.gov/legal/landlordacttoc.html</a>.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="45" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section>
        <div *ngIf="page === 21">
            <div class="container content-box module-content">


                <!-- EDIT PAST THIS LINE -->


                <h2>Renter’s Insurance</h2>
                <p>Insurance is a common method of risk management. Insured individuals transfer risks associated with large losses to an insurance company by buying insurance coverage. A renters insurance policy transfers three types of risks to the insurer:
                </p>
                <ol>
                    <li class="bullet-point">Replacement of personal belongings lost or damaged through theft, fire, or natural disaster.</li>
                    <li class="bullet-point">Coverage for living expenses if unit is unlivable.</li>
                    <li class="bullet-point">Protection against personal liability due to negligence.</li>
                </ol>
                <h3>Why You Need It</h3>
                <p>Insurance will help you cope with the stress of losing your things or suddenly being without a home because of a fire or natural disaster. If you cannot afford to replace your clothes, mattress, sofa, chairs, and other household goods,
                    you will appreciate a check from an insurance company to replace these things. You need to be protected if a visitor is injured while in your home. Furthermore, insurance may be required if stated in your lease.</p>
                <p>Everyone needs protection against personal liability. If you are not worried about the costs to replace your things or a place to stay, consider a policy with a high deductible.</p>
                <h3>How Do I Get It? How Do I Make a Good Decision?</h3>
                <p>Take an inventory. List everything you own, the date it was purchased, and the cost. Determine the value of the things you want to insure.</p>
                <h3>Shop Around and Ask Questions</h3>
                <p>Does the insurance cover the costs to replace your things or the actual cash value? Replacement value has a higher premium, however if many of your things have little cash value and would need to be replaced, it may be the better option.</p>
                <p>Ask for discounts if you do not smoke, have a security system, smoke detectors, sprinklers, and/or deadbolt locks. Call the agent who insures your car and ask for a discount on both policies. Get estimates from several insurance agents
                    to compare policies.</p>
                <p><b>MYTH: “I don’t need renters’ insurance. If our building burns down, the landlord’s insurance will replace my things.”</b> This a myth. Landlords insure the building, not tenants’ personal possessions. The landlord’s property insurance
                    does not extend to things inside tenants’ units.</p>
                <h3>After You Get Your Policy?</h3>
                <p>Here are some things you should do after getting renter’s insurance.</p>
                <ul class="bullet-points">
                    <li class="bullet-point">Review the policy <b>before</b> signing.</li>
                    <li class="bullet-point">File the policy in your <i>Organizer</i>.</li>
                    <li class="bullet-point">File a copy of the inventory or list of all your possessions with pictures or videotape in a safe place away from your home.</li>
                    <li class="bullet-point">Add purchases to your inventory and file receipts with pictures of the purchased item.</li>
                </ul>
                <p><i>For more information on renter’s insurance, contact:</i></p>
                <p>Independent Insurance Agents and Brokers of America<br>127 S. Peyton St.<br>Alexandria, VA 22314<br>Phone: (800) 211-7917; (703) 683-4422<br>Fax: (703) 683-7556<br>Web site: <a href="https://www.iiaba.net">www.iiaba.net</a></p>
                <p>The Insurance Information Institute<br>110 William Street<br>New York, NY 10038<br>Phone: (212) 346-5500<br>Web site: <a href="https://www.iii.org/">www.iii.org/</a></p>
                <p>Nebraska Department of Insurance<br>Consumer Affairs<br>Terminal Building<br>1135 M Street, Suite 300<br>Lincoln, NE 68508-3639<br>Phone: (402) 471-2201<br>Toll-Free Hotline: (877) 564-7323 (consumers only)</p>
                <p>Complete the <i>Renter’s Insurance — What do you Think? Worksheet 12</i> in the <i>Organizer</i> pocket.</p>


                <!-- DON'T EDIT PAST THIS LINE -->


            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <button type="button" class="btn waves-dark w-25" (click)="next($event)" [delay-click]="45" [delay-tooltip]="true">Next<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>

    <section *ngIf="page === 22">
        <div *ngVar="{ downloaded: false, validate: false } as content">
            <div class="container content-box module-content">
                <h2>Activity</h2>
                <h3> Go through your own lease agreement and write down the answers to the following questions or download the sample lease below. These are the things in your lease agreement that you need to know. Provided below are answers related to the sample lease.</h3>
                <div class="text-center">
                    <button type="button" class="btn waves-dark w-25" (click)="downloadActivityFive(); content.downloaded = true" [class.invalid]="content.validate && !content.downloaded">Download Handout</button>

                    <div class="invalid-feedback d-block" *ngIf="content.validate && !content.downloaded">
                      Download and review handout first.
                    </div>
                </div>
                <br>

                <ol type="1">
                    <li><b>When Does this lease end?</b></li>
                    <button *ngIf="page22_qclick[0]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[0] = false" [class.invalid]="content.validate && page22_qclick[0]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[0]">See section: FIXED-TERM AGREEMENT.</div>
                    <br>
                    <li><b>Who is responsible for the rent?</b></li>
                    <button *ngIf="page22_qclick[1]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[1] = false" [class.invalid]="content.validate && page22_qclick[1]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[1]">See top of lease agreement.</div>
                    <br>
                    <li><b>How long can visitors stay with you?</b></li>
                    <button *ngIf="page22_qclick[2]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[2] = false" [class.invalid]="content.validate && page22_qclick[2]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[2]">Tenants may house any single guest for a maximum of 14 days every six months.</div>
                    <br>
                    <li><b>How much is the rent?</b></li>
                    <button *ngIf="page22_qclick[3]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[3] = false" [class.invalid]="content.validate && page22_qclick[3]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[3]">See section: Rent.</div>
                    <br>
                    <li><b>When is the rent due?</b></li>
                    <button *ngIf="page22_qclick[4]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[4] = false" [class.invalid]="content.validate && page22_qclick[4]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[4]">The first of every calendar month.</div>
                    <br>
                    <li><b>Where do you pay the rent? To whom do you pay the rent?</b></li>
                    <button *ngIf="page22_qclick[5]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[5] = false" [class.invalid]="content.validate && page22_qclick[5]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[5]">The manager name and address should be listed on the lease agreement; see section: RENT PAYMENT PROCEDURE.</div>
                    <br>
                    <li><b>What utilities do you have to pay?</b></li>
                    <button *ngIf="page22_qclick[6]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[6] = false" [class.invalid]="content.validate && page22_qclick[6]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[6]">Tenants agree to pay all utilities and services with the exception of the following; see section UTILITIES/SERVICES.</div>
                    <br>
                    <li><b>Is there a penalty for late payment? What is it?</b></li>
                    <button *ngIf="page22_qclick[7]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[7] = false" [class.invalid]="content.validate && page22_qclick[7]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[7]">Yes, the penalty is 30$ payable immediately.</div>
                    <br>
                    <li><b>Are there payments you must make in addition to rent such as security deposit, parking, or utilities?</b></li>
                    <button *ngIf="page22_qclick[8]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[8] = false" [class.invalid]="content.validate && page22_qclick[8]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[8]">See section DEPOSITS.</div>
                    <br>
                    <li><b>When can the rent be increased?</b></li>
                    <button *ngIf="page22_qclick[9]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[9] = false" [class.invalid]="content.validate && page22_qclick[9]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[9]">Owners shall advise Tenants of any changes in terms of tenancy with advance notice of at least thirty (30) days.<br>Changes may include notices of termination, rent adjustments, or other reasonable changes in the terms of this Agreement.
                    </div>
                    <br>
                    <li><b>What happens if you move out before your lease period ends?</b></li>
                    <button *ngIf="page22_qclick[10]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[10] = false" [class.invalid]="content.validate && page22_qclick[10]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[10]">This lease may be canceled by the Tenants if all due rents are paid in full, proper notice is given, and by paying<br>a penalty equal to three times the monthly rent or the remaining rent due for the lease term, whichever is less.</div>
                    <br>
                    <li><b>How should the apartment look when you move out?</b></li>
                    <button *ngIf="page22_qclick[11]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[11] = false" [class.invalid]="content.validate && page22_qclick[11]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[11]">The rentle should look cleaned and empty.</div>
                    <br>
                    <li><b>Are pets permitted?</b></li>
                    <button *ngIf="page22_qclick[12]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[12] = false" [class.invalid]="content.validate && page22_qclick[12]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[12]">No pets are allowed.</div>
                    <br>
                    <li><b>Are you responsible for maintenance and repairs?</b></li>
                    <button *ngIf="page22_qclick[13]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[13] = false" [class.invalid]="content.validate && page22_qclick[13]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[13]">The owner will repair appliances owned by the owner at owner’s expense unless damaged by tenant or guests.</div>
                    <br>
                    <li><b>To whom do you report problems?</b></li>
                    <button *ngIf="page22_qclick[14]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[14] = false" [class.invalid]="content.validate && page22_qclick[14]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[14]">Tenants agree to notify the Owners immediately.</div>
                    <br>
                    <li><b>When can the landlord enter the apartment?</b></li>
                    <button *ngIf="page22_qclick[15]" type="button" class="btn waves-dark w-25" (click)="page22_qclick[15] = false" [class.invalid]="content.validate && page22_qclick[15]">Reveal Answer</button>
                    <div *ngIf="!page22_qclick[15]">Owners will schedule entry between the hours of 8 a.m. and 8 p.m., Monday through Saturday, excepting holidays,<br>and Owners will provide Tenants reasonable notice of twenty-four (24) hours or less than twenty-four (24) hours notice
                        <br>with Tenants’ concurrence. In emergencies, there will be no notice.</div>
                    <br>
                </ol>
            </div>
            <div class="container navigate-buttons">
                <button type="button" class="btn waves-dark w-25" (click)="back()"><i class="fas fa-angle-left mr-3"></i>Back</button>
                <div class="invalid-feedback inline-summary text-right" *ngIf="content.validate && (!content.downloaded || !allOf(page22_qclick, false))">Download handout at the top, complete and compare with answers using Reveal buttons.</div>
                <button type="button" class="btn waves-dark w-25" (click)="content.downloaded && allOf(page22_qclick, false) ? next($event) : content.validate = true" [delay-click]="20" [delay-tooltip]="true">Quiz<i class="fas fa-angle-right ml-3"></i></button>
            </div>
        </div>
    </section>
</div>


<section *ngIf="page === 23">
    <app-quiz-questions [questions]="questions" [moduleNumber]="4" (quizSubmitted)="handleQuiz($event)"></app-quiz-questions>
</section>
